import useStore from "../../../../../../lib/itn-ui-kit/data/store.js";
import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";

import Template from "./template.jsx";

export default class FinanceCasesDetailPayments extends BaseRoute {
  @service("repositories/settlement-check-repository") settlementCheckRepository;
  @service("repositories/entity-repository") entityRepository;

  element = (<Template />);

  async loader({ params, request }) {
    const { id } = params;
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    const settlementCheck = await this.settlementCheckRepository.query({
      ...searchParams,
      case: id,
      ordering: "-check_date",
    });
    const entityOpts = await this.entityRepository.query({ case: id, ordering: "name" });
    const settlementCheckOptions = await this.settlementCheckRepository.getOptions({ case: id });
    const count = useStore.getState().getTotalCount("settlement-check");

    return {
      settlementCheck,
      settlementCheckOptions,
      entityOpts,
      count,
    };
  }
}
